/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/error';
import '../../../omg/fulfillment/fulfillment';
import '../../../../google/protobuf/field_mask';
import './attributions';
import '../common/common';
import '../../../connect/v2/resources/location';
import '../common/geographic';
import '../common/fees';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fulfillment": {
        "nested": {
          "behaviors": {
            "nested": {
              "config": {
                "nested": {
                  "BehaviorConfigType": {
                    "values": {
                      "FULFILLMENT_SETTING_UNSPECIFIED": 0,
                      "ORDER_ACCEPTANCE": 1,
                      "SCHEDULING": 2,
                      "RECIPIENT_DETAILS": 3,
                      "CHECKOUT_MESSAGING": 4,
                      "FEES": 5,
                      "STATUS_TRACKING": 6,
                      "SELLER_POWERED_DELIVERY": 7,
                      "ON_DEMAND_DELIVERY": 8,
                      "CURBSIDE_PICKUP": 9
                    }
                  },
                  "FulfillmentMethods": {
                    "fields": {
                      "fulfillmentMethods": {
                        "type": ".squareup.fulfillment.behaviors.config.FulfillmentMethod",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "fulfillmentSelectionPromptConfig": {
                        "type": ".squareup.fulfillment.behaviors.config.FulfillmentSelectionPromptConfig",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListedFulfillmentMethods": {
                    "fields": {
                      "results": {
                        "type": ".squareup.fulfillment.behaviors.config.ListedFulfillmentMethods.Result",
                        "id": 1,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "Result": {
                        "fields": {
                          "fulfillmentMethod": {
                            "type": ".squareup.fulfillment.behaviors.config.FulfillmentMethod",
                            "id": 1
                          },
                          "errors": {
                            "type": ".squareup.fulfillment.behaviors.config.ListedFulfillmentMethods.Result.Errors",
                            "id": 2
                          }
                        },
                        "nested": {
                          "Errors": {
                            "fields": {
                              "errors": {
                                "type": ".squareup.connect.v2.resources.Error",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          },
                          "value": {
                            "oneof": ["fulfillmentMethod", "errors"]
                          }
                        }
                      }
                    }
                  },
                  "FulfillmentMethod": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.omg.fulfillment.FulfillmentType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "label": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "configFieldsMask": {
                        "type": ".google.protobuf.FieldMask",
                        "id": 4,
                        "rule": "optional"
                      },
                      "attributions": {
                        "type": ".squareup.fulfillment.behaviors.config.Attribution",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "orderAcceptance": {
                        "type": ".squareup.fulfillment.behaviors.config.OrderAcceptance",
                        "id": 5,
                        "rule": "optional"
                      },
                      "recipientDetailsConfig": {
                        "type": ".squareup.fulfillment.behaviors.config.RecipientDetailsConfig",
                        "id": 6,
                        "rule": "optional"
                      },
                      "tags": {
                        "type": ".squareup.fulfillment.behaviors.config.FulfillmentMethodTag",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "schedulingConfig": {
                        "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig",
                        "id": 9,
                        "rule": "optional"
                      },
                      "checkoutMessaging": {
                        "type": ".squareup.fulfillment.behaviors.config.CheckoutMessaging",
                        "id": 10,
                        "rule": "optional"
                      },
                      "statusTracking": {
                        "type": ".squareup.fulfillment.behaviors.config.StatusTracking",
                        "id": 12,
                        "rule": "optional"
                      },
                      "sellerPoweredDelivery": {
                        "type": ".squareup.fulfillment.behaviors.config.SellerPoweredDeliveryConfig",
                        "id": 13,
                        "rule": "optional"
                      },
                      "onDemandDelivery": {
                        "type": ".squareup.fulfillment.behaviors.config.OnDemandDeliveryConfig",
                        "id": 14,
                        "rule": "optional"
                      },
                      "diningOptionId": {
                        "type": "string",
                        "id": 16,
                        "rule": "optional"
                      },
                      "curbsidePickup": {
                        "type": ".squareup.fulfillment.behaviors.config.CurbsidePickupConfig",
                        "id": 17,
                        "rule": "optional"
                      },
                      "catalogVersion": {
                        "type": "int64",
                        "id": 18,
                        "rule": "optional"
                      },
                      "checkoutEligibility": {
                        "type": ".squareup.fulfillment.behaviors.config.CheckoutEligibility",
                        "id": 19,
                        "rule": "optional"
                      }
                    }
                  },
                  "FulfillmentMethodTag": {
                    "values": {
                      "FULFILLMENT_METHOD_TAG_DO_NOT_USE": 0,
                      "DRIVE_THRU": 1
                    }
                  },
                  "DeviceProfileFulfillmentMethods": {
                    "fields": {
                      "fulfillmentMethods": {
                        "type": ".squareup.fulfillment.behaviors.config.FulfillmentMethod",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "hiddenFromDeviceProfile": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "hiddenAtLocation": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "defaultFulfillmentMethodId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "OrderAcceptance": {
                    "fields": {
                      "acceptingOrders": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "nextAcceptingAt": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "orderSubtotalCriteriaRange": {
                        "type": ".squareup.fulfillment.behaviors.common.MoneyRange",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxItemQuantity": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "largeOrderLimitMessage": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "RecipientDetailsConfig": {
                    "fields": {
                      "fields": {
                        "type": ".squareup.fulfillment.behaviors.config.RecipientDetailCollectionConfigField",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "RecipientDetailCollectionConfigFieldType": {
                    "values": {
                      "FIELD_TYPE_UNSPECIFIED": 0,
                      "PHONE": 1,
                      "NAME": 2,
                      "ADDRESS": 3,
                      "GUEST_IDENTIFIER": 4,
                      "NOTE": 5,
                      "VEHICLE_TYPE": 6,
                      "VEHICLE_COLOR": 7,
                      "CUSTOMER_LOOKUP": 8,
                      "PARKING_SPOT": 9
                    }
                  },
                  "RecipientDetailCollectionConfigField": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.fulfillment.behaviors.config.RecipientDetailCollectionConfigFieldType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "required": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "recipientIdentifierConfig": {
                        "type": ".squareup.fulfillment.behaviors.config.RecipientIdentifierConfig",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "RecipientIdentifierConfig": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "rank": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "FulfillmentSelectionPromptConfig": {
                    "fields": {
                      "promptingEvent": {
                        "type": ".squareup.fulfillment.behaviors.config.PromptingEvent",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "PromptingEvent": {
                    "values": {
                      "DISABLED": 0,
                      "BEFORE_ORDER_CREATION": 1,
                      "BEFORE_PAYMENT_OR_SEND": 2,
                      "UNSET": 3
                    }
                  },
                  "SchedulingConfig": {
                    "fields": {
                      "prepTimeDuration": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "timezone": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hours": {
                        "type": ".squareup.connect.v2.resources.BusinessHoursPeriod",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "futureScheduling": {
                        "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.FutureScheduling",
                        "id": 4,
                        "rule": "optional"
                      },
                      "leadTimeScheduling": {
                        "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.LeadTimeScheduling",
                        "id": 5,
                        "rule": "optional"
                      },
                      "cutoffTime": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "providesSchedules": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "orderThrottling": {
                        "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling",
                        "id": 8,
                        "rule": "optional"
                      },
                      "specialFulfillmentHours": {
                        "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.SpecialFulfillmentHours",
                        "id": 9,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "FutureScheduling": {
                        "fields": {
                          "enabled": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "maxSchedulingHorizon": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "LeadTimeScheduling": {
                        "fields": {
                          "enabled": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "advanceDurationNotice": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cutoffTime": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "startOfDayOffsetDuration": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "OrderThrottling": {
                        "fields": {
                          "active": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "type": {
                            "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling.ThrottlingType",
                            "id": 2,
                            "rule": "optional"
                          },
                          "byCount": {
                            "type": ".squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling.ByCountThrottling",
                            "id": 3
                          }
                        },
                        "nested": {
                          "ThrottlingType": {
                            "values": {
                              "THROTTLING_TYPE_UNSPECIFIED": 0,
                              "THROTTLING_TYPE_BY_COUNT": 1
                            }
                          },
                          "ByCountThrottling": {
                            "fields": {
                              "maxOrderCount": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional"
                              },
                              "timeWindowDuration": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "strategy": {
                            "oneof": ["byCount"]
                          }
                        }
                      },
                      "SpecialFulfillmentHours": {
                        "fields": {
                          "period": {
                            "type": ".squareup.connect.v2.resources.SpecialBusinessHoursPeriod",
                            "id": 1,
                            "rule": "optional"
                          },
                          "recurrence": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CheckoutMessaging": {
                    "fields": {
                      "buyerInstructionsText": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "StatusTracking": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SellerPoweredDeliveryConfig": {
                    "fields": {
                      "deliveryAreas": {
                        "type": ".squareup.fulfillment.behaviors.config.SellerPoweredDeliveryConfig.DeliveryArea",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "noContactDeliveryEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "enabled": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "providesDeliveryEta": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DeliveryArea": {
                        "fields": {
                          "deliveryArea": {
                            "type": ".squareup.fulfillment.behaviors.common.GeographicArea",
                            "id": 1,
                            "rule": "optional"
                          },
                          "fees": {
                            "type": ".squareup.fulfillment.behaviors.common.Fee",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "enabled": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "deliveryTravelTimeEstimate": {
                            "type": ".squareup.fulfillment.behaviors.common.TimeRange",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "OnDemandDeliveryConfig": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fees": {
                        "type": ".squareup.fulfillment.behaviors.common.Fee",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "CurbsidePickupConfig": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "instructions": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "recipientDetailsConfig": {
                        "type": ".squareup.fulfillment.behaviors.config.RecipientDetailsConfig",
                        "id": 3,
                        "rule": "optional"
                      },
                      "posAlertsEnabled": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "CheckoutEligibilityRequirement": {
                    "fields": {
                      "type": {
                        "type": ".squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subscriptionTier": {
                        "type": ".squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement.SubscriptionTierParams",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "CHECKOUT_ELIGIBILITY_TYPE_UNSPECIFIED": 0,
                          "CHECKOUT_ELIGIBILITY_SUBSCRIPTION_TIER": 1
                        }
                      },
                      "SubscriptionTierParams": {
                        "fields": {
                          "requiredTier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "params": {
                        "oneof": ["subscriptionTier"]
                      }
                    }
                  },
                  "CheckoutEligibility": {
                    "fields": {
                      "unmetRequirements": {
                        "type": ".squareup.fulfillment.behaviors.config.UnmetCheckoutEligibilityRequirement",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "UnmetCheckoutEligibilityRequirement": {
                    "fields": {
                      "type": {
                        "type": ".squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subscriptionTier": {
                        "type": ".squareup.fulfillment.behaviors.config.UnmetCheckoutEligibilityRequirement.SubscriptionTierDetails",
                        "id": 2
                      }
                    },
                    "nested": {
                      "SubscriptionTierDetails": {
                        "fields": {
                          "requiredTier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "currentTier": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "details": {
                        "oneof": ["subscriptionTier"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.BehaviorConfigType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.FulfillmentMethods && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.ListedFulfillmentMethods && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.ListedFulfillmentMethods?.nested?.Result && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.ListedFulfillmentMethods?.nested?.Result?.nested?.Errors && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.FulfillmentMethod && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.FulfillmentMethodTag && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.DeviceProfileFulfillmentMethods && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.OrderAcceptance && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.RecipientDetailsConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.RecipientDetailCollectionConfigFieldType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.RecipientDetailCollectionConfigField && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.RecipientIdentifierConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.FulfillmentSelectionPromptConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.PromptingEvent && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.FutureScheduling && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.LeadTimeScheduling && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.OrderThrottling && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.OrderThrottling?.nested?.ThrottlingType && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.OrderThrottling?.nested?.ByCountThrottling && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SchedulingConfig?.nested?.SpecialFulfillmentHours && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CheckoutMessaging && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.StatusTracking && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SellerPoweredDeliveryConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.SellerPoweredDeliveryConfig?.nested?.DeliveryArea && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.OnDemandDeliveryConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CurbsidePickupConfig && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CheckoutEligibilityRequirement && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CheckoutEligibilityRequirement?.nested?.Type && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CheckoutEligibilityRequirement?.nested?.SubscriptionTierParams && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.CheckoutEligibility && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.UnmetCheckoutEligibilityRequirement && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.config?.nested?.UnmetCheckoutEligibilityRequirement?.nested?.SubscriptionTierDetails) {
  $root.addJSON(jsonData);
}

/**
 * Logical fulfillment settings that can be configured for different fulfillment methods.
 * These represent business concepts rather than specific settings-hub field paths,
 * providing a stable abstraction layer that can evolve independently of the
 * underlying storage implementation.
 *
 * NAMING CONVENTIONS:
 *
 *   Types in this file *describe behaviors* of the fulfillment capabilities that
 *   comprise the overall fulfillment workflow a Fulfillment Method represents.
 *
 *   Fields SHOULD use present-participle / active voice (e.g. `provides_schedules`,
 *   `active`, `supports_no_contact_delivery`) rather than past participle
 *   (e.g. avoid `enabled`, `no_contact_delivery_enabled`, `eta_calculation_enabled`).
 *
 * SOURCE BehaviorConfigType @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 32:1
 */
export const BehaviorConfigType = $root.lookupEnum('squareup.fulfillment.behaviors.config.BehaviorConfigType').values;
/**
 * Client result proto containing a list of available fulfillment methods.
 * This is what gets returned to clients requesting fulfillment methods.
 *
 * SOURCE FulfillmentMethods @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 95:1
 */
export const FulfillmentMethods = $root.lookupType('squareup.fulfillment.behaviors.config.FulfillmentMethods');
fixType(FulfillmentMethods);
Builder.createAndAttachToType(FulfillmentMethods);
/**
 * SOURCE ListedFulfillmentMethods @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 107:1
 */
export const ListedFulfillmentMethods = $root.lookupType('squareup.fulfillment.behaviors.config.ListedFulfillmentMethods');
fixType(ListedFulfillmentMethods);
Builder.createAndAttachToType(ListedFulfillmentMethods);
/**
 * SOURCE Result @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 111:3
 */
ListedFulfillmentMethods.Result = $root.lookupType('squareup.fulfillment.behaviors.config.ListedFulfillmentMethods.Result');
fixType(ListedFulfillmentMethods.Result);
Builder.createAndAttachToType(ListedFulfillmentMethods.Result);
/**
 * SOURCE Errors @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 119:5
 */
ListedFulfillmentMethods.Result.Errors = $root.lookupType('squareup.fulfillment.behaviors.config.ListedFulfillmentMethods.Result.Errors');
fixType(ListedFulfillmentMethods.Result.Errors);
Builder.createAndAttachToType(ListedFulfillmentMethods.Result.Errors);
/**
 * A single fulfillment method available to the client.
 *
 * SOURCE FulfillmentMethod @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 128:1
 */
export const FulfillmentMethod = $root.lookupType('squareup.fulfillment.behaviors.config.FulfillmentMethod');
fixType(FulfillmentMethod);
Builder.createAndAttachToType(FulfillmentMethod);
/**
 * The FulfillmentMethodTag helps clients group different fulfillment methods that fall under the
 * same umbrella. For example, a seller may want to view multiple fulfillment methods in the same
 * report or order manager view. The FulfillmentMethodTag could be used to group the methods.
 *
 * At this time, FulfillmentMethodTags are not designed to be configured by sellers.
 *
 * This enum provides a strongly typed definition of a tag and allow for better governance of which
 * tags are added. Please reach out to Fulfillments team for guidance if looking to add a new tag.
 *
 * SOURCE FulfillmentMethodTag @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 225:1
 */
export const FulfillmentMethodTag = $root.lookupEnum('squareup.fulfillment.behaviors.config.FulfillmentMethodTag').values;
/**
 * Fulfillment methods available for a device profile context, including visibility and default settings.
 * Combines native fulfillment methods with converted fulfillment labels, annotated with device profile
 * and location-level visibility controls.
 *
 * SOURCE DeviceProfileFulfillmentMethods @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 236:1
 */
export const DeviceProfileFulfillmentMethods = $root.lookupType('squareup.fulfillment.behaviors.config.DeviceProfileFulfillmentMethods');
fixType(DeviceProfileFulfillmentMethods);
Builder.createAndAttachToType(DeviceProfileFulfillmentMethods);
/**
 * SOURCE OrderAcceptance @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 250:1
 */
export const OrderAcceptance = $root.lookupType('squareup.fulfillment.behaviors.config.OrderAcceptance');
fixType(OrderAcceptance);
Builder.createAndAttachToType(OrderAcceptance);
/**
 * Configuration for collecting recipient details for a fulfillment method.
 *
 * SOURCE RecipientDetailsConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 281:1
 */
export const RecipientDetailsConfig = $root.lookupType('squareup.fulfillment.behaviors.config.RecipientDetailsConfig');
fixType(RecipientDetailsConfig);
Builder.createAndAttachToType(RecipientDetailsConfig);
/**
 * Types of recipient detail fields that can be collected.
 *
 * SOURCE RecipientDetailCollectionConfigFieldType @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 288:1
 */
export const RecipientDetailCollectionConfigFieldType = $root.lookupEnum('squareup.fulfillment.behaviors.config.RecipientDetailCollectionConfigFieldType').values;
/**
 * Configuration for a single recipient detail field.
 *
 * SOURCE RecipientDetailCollectionConfigField @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 304:1
 */
export const RecipientDetailCollectionConfigField = $root.lookupType('squareup.fulfillment.behaviors.config.RecipientDetailCollectionConfigField');
fixType(RecipientDetailCollectionConfigField);
Builder.createAndAttachToType(RecipientDetailCollectionConfigField);
/**
 * Recipient identifier configuration
 *
 * SOURCE RecipientIdentifierConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 314:1
 */
export const RecipientIdentifierConfig = $root.lookupType('squareup.fulfillment.behaviors.config.RecipientIdentifierConfig');
fixType(RecipientIdentifierConfig);
Builder.createAndAttachToType(RecipientIdentifierConfig);
/**
 * Configuration managing prompt settings when selecting a fulfillment method on POS.
 *
 * SOURCE FulfillmentSelectionPromptConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 330:1
 */
export const FulfillmentSelectionPromptConfig = $root.lookupType('squareup.fulfillment.behaviors.config.FulfillmentSelectionPromptConfig');
fixType(FulfillmentSelectionPromptConfig);
Builder.createAndAttachToType(FulfillmentSelectionPromptConfig);
/**
 * @desc The prompting event at which to show the FulfillmentMethod prompt.
 *
 * SOURCE PromptingEvent @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 340:1
 */
export const PromptingEvent = $root.lookupEnum('squareup.fulfillment.behaviors.config.PromptingEvent').values;
/**
 * Client-facing scheduling configuration for a fulfillment method.
 *
 * SOURCE SchedulingConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 350:1
 */
export const SchedulingConfig = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig');
fixType(SchedulingConfig);
Builder.createAndAttachToType(SchedulingConfig);
/**
 * SOURCE FutureScheduling @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 368:3
 */
SchedulingConfig.FutureScheduling = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig.FutureScheduling');
fixType(SchedulingConfig.FutureScheduling);
Builder.createAndAttachToType(SchedulingConfig.FutureScheduling);
/**
 * SOURCE LeadTimeScheduling @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 383:3
 */
SchedulingConfig.LeadTimeScheduling = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig.LeadTimeScheduling');
fixType(SchedulingConfig.LeadTimeScheduling);
Builder.createAndAttachToType(SchedulingConfig.LeadTimeScheduling);
/**
 * SOURCE OrderThrottling @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 431:3
 */
SchedulingConfig.OrderThrottling = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling');
fixType(SchedulingConfig.OrderThrottling);
Builder.createAndAttachToType(SchedulingConfig.OrderThrottling);
/**
 * SOURCE ThrottlingType @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 437:5
 */
SchedulingConfig.OrderThrottling.ThrottlingType = $root.lookupEnum('squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling.ThrottlingType').values;
/**
 * SOURCE ByCountThrottling @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 454:5
 */
SchedulingConfig.OrderThrottling.ByCountThrottling = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig.OrderThrottling.ByCountThrottling');
fixType(SchedulingConfig.OrderThrottling.ByCountThrottling);
Builder.createAndAttachToType(SchedulingConfig.OrderThrottling.ByCountThrottling);
/**
 * SOURCE SpecialFulfillmentHours @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 467:3
 */
SchedulingConfig.SpecialFulfillmentHours = $root.lookupType('squareup.fulfillment.behaviors.config.SchedulingConfig.SpecialFulfillmentHours');
fixType(SchedulingConfig.SpecialFulfillmentHours);
Builder.createAndAttachToType(SchedulingConfig.SpecialFulfillmentHours);
/**
 * SOURCE CheckoutMessaging @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 483:1
 */
export const CheckoutMessaging = $root.lookupType('squareup.fulfillment.behaviors.config.CheckoutMessaging');
fixType(CheckoutMessaging);
Builder.createAndAttachToType(CheckoutMessaging);
/**
 * SOURCE StatusTracking @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 490:1
 */
export const StatusTracking = $root.lookupType('squareup.fulfillment.behaviors.config.StatusTracking');
fixType(StatusTracking);
Builder.createAndAttachToType(StatusTracking);
/**
 * ===== Seller Powered Delivery Types =====
 * Seller powered delivery configuration returned to client applications.
 * Provides fee information, geographic availability, and delivery options.
 *
 * SOURCE SellerPoweredDeliveryConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 502:1
 */
export const SellerPoweredDeliveryConfig = $root.lookupType('squareup.fulfillment.behaviors.config.SellerPoweredDeliveryConfig');
fixType(SellerPoweredDeliveryConfig);
Builder.createAndAttachToType(SellerPoweredDeliveryConfig);
/**
 * Delivery area configuration associating a geographic area with its delivery settings.
 *
 * SOURCE DeliveryArea @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 529:3
 */
SellerPoweredDeliveryConfig.DeliveryArea = $root.lookupType('squareup.fulfillment.behaviors.config.SellerPoweredDeliveryConfig.DeliveryArea');
fixType(SellerPoweredDeliveryConfig.DeliveryArea);
Builder.createAndAttachToType(SellerPoweredDeliveryConfig.DeliveryArea);
/**
 * On-demand delivery configuration returned to client applications.
 * Provides fee information and specialized on-demand delivery options.
 *
 * SOURCE OnDemandDeliveryConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 558:1
 */
export const OnDemandDeliveryConfig = $root.lookupType('squareup.fulfillment.behaviors.config.OnDemandDeliveryConfig');
fixType(OnDemandDeliveryConfig);
Builder.createAndAttachToType(OnDemandDeliveryConfig);
/**
 * Curbside pickup configuration returned to client applications.
 * Provides enablement, instructions, recipient details collection, and POS alert settings.
 *
 * SOURCE CurbsidePickupConfig @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 575:1
 */
export const CurbsidePickupConfig = $root.lookupType('squareup.fulfillment.behaviors.config.CurbsidePickupConfig');
fixType(CurbsidePickupConfig);
Builder.createAndAttachToType(CurbsidePickupConfig);
/**
 * A requirement that must be satisfied for a fulfillment method to be
 * eligible for checkout. Passed through from the FulfillmentMethodDefinition
 * for clients to evaluate against the seller's current context.
 *
 * SOURCE CheckoutEligibilityRequirement @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 594:1
 */
export const CheckoutEligibilityRequirement = $root.lookupType('squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement');
fixType(CheckoutEligibilityRequirement);
Builder.createAndAttachToType(CheckoutEligibilityRequirement);
/**
 * SOURCE Type @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 595:3
 */
CheckoutEligibilityRequirement.Type = $root.lookupEnum('squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement.Type').values;
/**
 * SOURCE SubscriptionTierParams @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 601:3
 */
CheckoutEligibilityRequirement.SubscriptionTierParams = $root.lookupType('squareup.fulfillment.behaviors.config.CheckoutEligibilityRequirement.SubscriptionTierParams');
fixType(CheckoutEligibilityRequirement.SubscriptionTierParams);
Builder.createAndAttachToType(CheckoutEligibilityRequirement.SubscriptionTierParams);
/**
 * Checkout eligibility results for a fulfillment method, evaluated by CLS.
 * Contains only the requirements that were NOT satisfied for the current seller context.
 * An empty unmet_requirements list means the fulfillment method is fully eligible for checkout.
 *
 * SOURCE CheckoutEligibility @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 620:1
 */
export const CheckoutEligibility = $root.lookupType('squareup.fulfillment.behaviors.config.CheckoutEligibility');
fixType(CheckoutEligibility);
Builder.createAndAttachToType(CheckoutEligibility);
/**
 * Represents a checkout eligibility requirement that was evaluated
 * and not satisfied for the current seller context.
 *
 * SOURCE UnmetCheckoutEligibilityRequirement @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 628:1
 */
export const UnmetCheckoutEligibilityRequirement = $root.lookupType('squareup.fulfillment.behaviors.config.UnmetCheckoutEligibilityRequirement');
fixType(UnmetCheckoutEligibilityRequirement);
Builder.createAndAttachToType(UnmetCheckoutEligibilityRequirement);
/**
 * SOURCE SubscriptionTierDetails @ squareup/fulfillment/behaviors/client/fulfillment_methods_client.proto at 629:3
 */
UnmetCheckoutEligibilityRequirement.SubscriptionTierDetails = $root.lookupType('squareup.fulfillment.behaviors.config.UnmetCheckoutEligibilityRequirement.SubscriptionTierDetails');
fixType(UnmetCheckoutEligibilityRequirement.SubscriptionTierDetails);
Builder.createAndAttachToType(UnmetCheckoutEligibilityRequirement.SubscriptionTierDetails);